import api from "../services/api";

export type UpdateSiteConfigurationDTO = {
  homeCoverImageUrl?: string | null;
  pointsEnabled?: boolean;
  pointsValidityMonths?: number;
  pointsToEgpRate?: number;
  minPointsToConvert?: number;
  reservationPointsPerEgp?: number;
  registrationPointsPerEgp?: number;
  // Blank clears the details; leaving the field out keeps them.
  instaPayDetails?: string;
};

export const getSiteConfiguration = () => api.get("SiteConfiguration");
export const updateSiteConfiguration = (data: UpdateSiteConfigurationDTO) =>
  api.put("SiteConfiguration", data);
